export default {
  props: {
    previewVisible: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      previewPDF: '',
      isPDFShow: false
    };
  },
  methods: {
    isPDF(filePath) {
      // 是否为PDF
      const types = ['pdf'];
      const type = this.fileExtension(filePath);
      return types.indexOf(type) !== -1;
    },
    // 获取文件后缀类型
    fileExtension(filePath) {
      // 获取最后一个.的位置
      const index = filePath.lastIndexOf('.');
      // 获取后缀
      const type = filePath.substr(index + 1);
      // 返回类型
      return type.toLowerCase();
    },
    // 预览处理
    async handlePreview(file) {
      this.isPDFShow = this.isPDF(file.name);
      if (this.isPDFShow) {
        this.previewPDF = file.url;
        window.open(this.previewPDF);
        return;
      }
    }
  }
};